var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"print-hide px-0",staticStyle:{"background":"#242c42"},attrs:{"height":"auto"}},[_c('FooterContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }